import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { useReactiveVar } from "react-reactive-var";
import { isMobileScreen } from "../../Screens/MainViewContainer";

const AnnouncementBanner = ({ announcement, onClose }) => {
  const { currentTheme } = AppTheme.useTheme();
  const isMobile = useReactiveVar(isMobileScreen);
  const styles = generateStyles({ currentTheme, isMobile });

  if (!announcement) return null;

  return (
    <View style={styles.container}>
      <AppText
        style={styles.text}
        color={currentTheme?.theme?.white}
        numberOfLines={2}
      >
        {announcement}
      </AppText>
      <AppIcon
        isClickable
        icon={AppAssets.icons.close}
        size={14}
        color={currentTheme?.theme?.white}
        wrapperStyle={styles.closeButton}
        onPress={onClose}
      />
    </View>
  );
};

const generateStyles = ({ currentTheme, isMobile }) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: currentTheme?.theme?.primary,
      paddingVertical: 5,
      gap: 7,
      paddingHorizontal: 3,
      // paddingHorizontal: isMobile ? 16 : 100,
      borderBottomColor: currentTheme?.theme?.border_color,
      borderBottomWidth: 1,
      minHeight: 35,
      position: "absolute",
      zIndex: 1000,
      minWidth: isMobile ? 250 : 350,
      maxWidth: "80%",
      alignSelf: "center",
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
      // Allow clicks to pass through Electron's draggable titlebar
      appRegion: "no-drag",
      WebkitAppRegion: "no-drag",
    },
    text: {
      fontSize: 12,
      fontWeight: "500",
      flex: 1,
      textAlign: "center",
    },
    closeButton: {
      left: 0,
      // Ensure close button is clickable in Electron
      appRegion: "no-drag",
      WebkitAppRegion: "no-drag",
    },
  });

export default AnnouncementBanner;
